import React from 'react';
import PropTypes from 'prop-types';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMReservationHelper from 'components/helpers/SMReservationHelper';

class SMReservationEditViewCheckinTime extends React.Component{
  
  selectBoxDidChangeValue(e) {
    this.props.delegate.changeCheckinTime(e.currentTarget.name, e.currentTarget.value);
  }
  
  generateCheckinTimePullDown(checkinHour, checkoutHour) {
    let selectBoxItems = [];
    
    for (let i = checkinHour; i < checkoutHour; i++) {
      selectBoxItems.push({
        value: i.toString() + ":00",
        label: i.toString() + ":00"
      });

      selectBoxItems.push({
        value: i.toString() + ":30",
        label: i.toString() + ":30"
      });
    }

    selectBoxItems.push({
      value: checkinHour.toString() + ":00",
      label: checkoutHour.toString() + ":00"
    });
    
    return selectBoxItems;
  }
  
  render() {
    const room = this.props.room;
    const reservation = this.props.reservation;
    const stayCheckinAt = this.props.stayCheckinAt;
    const strStayCheckinHour = 
      stayCheckinAt ? stayCheckinAt.getHours() : null;
    const strStayCheckinMinute = 
      stayCheckinAt ? ("0" + (stayCheckinAt.getMinutes())).slice(-2) : null;
    // 部屋ごとに決められたチェックイン、チェックアウト時間を取得
    const roomCheckinHour = 
      room != null ? room.stay_checkin_start_hour : 0;
    const roomCheckoutHour = 
      room != null ? room.stay_checkin_end_hour : 0;
    
    return(
      <td>
        <span className="form-select__inner">
          <label className="form-select">
            <SMFormSelectBox
              name='stay_checkin_hour'
              ref='stayCheckinHour'
              items={this.generateCheckinTimePullDown(roomCheckinHour, roomCheckoutHour)}
              selectedValue={strStayCheckinHour + ":" + strStayCheckinMinute}
              delegate={this}
              options={{className:'w110', disabled: !SMReservationHelper.isDetailEditable(reservation)}} />
          </label>
        </span>
        <span className="ml10">
        </span>
      </td>
    );
  }
}

SMReservationEditViewCheckinTime.propTypes = {
  reservation: PropTypes.object.isRequired,
  stayCheckinAt: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewCheckinTime;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewCheckinTime.jsx